// React Basic and Bootstrap
import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

import { feature_array } from "../../common/data/feature_array";
import dashboard from "../../assets/images/itoagent/dashboard.png";

const Dashboard = () => {

  return (

    <React.Fragment>

      <Container className="mt-30">
          <Row className="justify-content-center">
              <Col lg={12} className="text-center mt-0 mt-md-5 pt-0 pt-md-5">
                 <img src={dashboard} alt="" className="img-fluid" />
              </Col>
          </Row>
      </Container>

      <Container className="mt-100">

         <Row>
          {feature_array.map((feat, i) => {
            return (
              <Col md={4} xs={12} key={i} name="featurebox">
                <div
                  className="features feature-primary text-center"
                >
                  <div className="image position-relative d-inline-block">
                    {/**
                    <i className={feat.icon} >
                    </i>
                     **/}
                  </div>
                  <div className="content mt-4">
                    <h5>{feat.title}</h5>
                    <p className="text-muted mb-0">{feat.description}</p>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>

        </Container>

    </React.Fragment>
  );
}

export default Dashboard;
